import { fetchAllPosData } from '../../database/fetch-pos-data';

const getPosData = (callback) => {
  return fetchAllPosData((poss) => {
    const unsortedPosData = poss
      .map((pos) => {
        if (!pos) return null;

        const originalDate = new Date(pos.awardedDate);

        const day = originalDate.getDate();
        const month = originalDate.getMonth() + 1;
        const year = originalDate.getFullYear();
        const formattedDate = `${month.toString().padStart(2, '0')}-${day
          .toString()
          .padStart(2, '0')}-${year}`;

        const packetsAttachmentsLength = pos.packetsAttachments?.length || 0;
        const posAttachmentsLength = pos.posAttachments?.length || 0;
        const attachmentsLength = pos.attachments?.length || 0;

        const totalAttachments =
          packetsAttachmentsLength + posAttachmentsLength + attachmentsLength;

        return {
          uniqueId: pos.posId || pos.docId,
          spo: pos.spo || '',
          rfqNo: pos.rfqNo || '',
          agency: pos.agency || '',
          contractingOfficer: pos.primaryContactName || '',
          email: pos.primaryEmail || pos.primarySenderEmail || '',
          awardedDate: formattedDate,
          awardedDateObj: originalDate, // keep original for sorting
          lineItems: pos.items?.length || 0,
          attachments: totalAttachments,
          quotes: pos.modifiedQuotes?.length || 0,
          comments: pos.comments || '',
          invoiceStatus: pos.invoiceStatus || 'not_paid',
          totalPOInvoice: pos.totalPOInvoice || 0,
          remainingAmount: pos.remainingAmount || pos.totalPOInvoice || 0,
        };
      })
      .filter(Boolean);

    const sortedPosData = unsortedPosData
      .sort((a, b) => b.awardedDateObj - a.awardedDateObj) // newest first
      .map((pos, index) => {
        const { awardedDateObj, ...rest } = pos;
        return {
          ...rest,
          no: index + 1, // correct numbering after sorting
        };
      });

    callback(sortedPosData);
  });
};

export default getPosData;
